const { useMediaQuery } = require('@mui/material');

const useCustomMediaQueries = () => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down(450));
  const isTablet = useMediaQuery((theme) => theme.breakpoints.down('md'));
  return { isMobile, isTablet };
};

export default useCustomMediaQueries;
